module.exports = __webpack_public_path__ + "static/img/labour-love-2.b16f8ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/labour-love-2.svg
// module id = FKwy
// module chunks = 1